<script setup lang="ts">
import { onError, onHide, onLaunch, onShow, onPageNotFound } from '@dcloudio/uni-app';
import { businessUtils, commonUtils, toast } from './utils';
import errorManager, { ErrorManagerEntryType } from './utils/errorManager';
import { PAGE_PATH } from '@/constants';

onLaunch(() => {
  commonUtils.mp.removeLog();
  console.log('[App Launch] => 冷启动');


  // 加载七鱼客服 SDK
  businessUtils.qiyu.loadQiyuSDK().then(() => {
    console.log('[七鱼客服] SDK 加载完成');
  });

});

onShow(async (options) => {
  console.log('[App onShow] => 热启动', options);

  // businessUtils.mp.mockUser('');

  /** 埋点加载 */
  businessUtils.matomo.load();

  // 监听登录状态
  await businessUtils.login.watch();

  // 检查登录token
  await businessUtils.login.check();

  // onshow处理
  businessUtils.mp.show(options);

  // 场景值处理
  businessUtils.mp.scene(options);

  // 检查更新
  commonUtils.mp.update();
});

onHide(() => {
  console.log('[ App Hide ]');
});

onError((error) => {
  toast.clear();
  errorManager.report(ErrorManagerEntryType.wechatApplication, {
    message: 'App throw error',
    stack: error,
  });
  console.log(`[App onError] => `, error);
});

onPageNotFound((page) => {
  console.log("页面不存在监听函数", page);

  const path = page.path.replace(/^\/+/, "");
  const queryStr = Object.keys(page.query)
  .map(key => `${key}=${encodeURIComponent(page.query[key])}`)
  .join("&");
  
  // 兼容分包前的path
  switch (path) {
    case "pages/subpack-main/commodity/index":
      uni.reLaunch({ url: `${PAGE_PATH.commodity.route}?${queryStr}` });
      break;
    case "pages/subpack-main/activity/index":
      uni.reLaunch({ url: `${PAGE_PATH.activity.route}?${queryStr}` });
      break;
    default:
      uni.reLaunch({ url: PAGE_PATH.home.route });
      break;
  }
})
</script>

<style lang="scss">
@font-face {
  font-family: din-bold;
  src: url('https://cdn.s3.mall.startcatcher.com/public/D-DINExp-Bold.ttf') format('truetype');
}

@font-face {
  font-family: din;
  src: url('https://cdn.s3.mall.startcatcher.com/public/D-DINExp.ttf') format('truetype');
}

@font-face {
  font-family: siyuan-bold;
  src: url('https://cdn.s3.mall.startcatcher.com/public/SourceHanSansCN-Bold.otf')
    format('truetype');
}

@font-face {
  font-family: siyuan;
  src: url('https://cdn.s3.mall.startcatcher.com/public/SourceHanSansCN-Normal.otf')
    format('truetype');
}

page {
  height: 100%;
  font-size: 28rpx;
}


uni-page-head {
  display: none;
}


:not(not) {
  box-sizing: border-box;
}

.uni-load-more :deep(.uni-load-more__text) {
  font-size: 24rpx;
}

[v-cloak] {
  display: none !important;
}

::-webkit-scrollbar-track {
  z-index: 9999;
}

::-webkit-scrollbar-thumb {
  z-index: 9999;
}
</style>
